<template>
  <div class="event" v-in-viewport.once :data-opera="event.opera" :data-ballet="event.ballet">
    <div>
      <a :href="event.link" target="_blank" v-on:mousedown="mousedown" v-on:mouseup="mouseup" v-on:click="canClick">
        <div class="imagewrapper pb-138">
          <img :src="event.image" class="rs event__image">
        </div>
        <div class="event__bg-gradient"></div>
        <div class="event__logos">
          <ul class="inline">
            <li v-if="event.opera==1"><img src="/images/logo-opera.png" /></li>
            <li v-if="event.ballet==1"><img src="/images/logo-ballet.png" /></li>
          </ul>
        </div>
        <div class="event__bottom">
          <p class="title-h2" v-html="event.title"></p>
          <p class="small" v-html="event.date"></p>
          <a v-if="event.resa" :href="event.resa" class="round-button round-button--white mobile" target="_blank">Réserver</a>
        </div>
        <a v-if="event.resa" :href="event.resa" class="round-button round-button--white desktop" target="_blank">Réserver</a>
      </a>
    </div>
  </div>
</template>

<style lang="scss">
.event{
  color: white;
  width: 100%;
  text-align: left;
  overflow: hidden;
  span{
    color: white;
  }

  & > *{
    opacity: 0;
    transition: all .8s ease .3s;
    .agenda__events &{
      transform: translate3d(0,20%,0);
    }
  }

  &.in-viewport{
    & > *{
      opacity: 1;
      transform: translate3d(0,0%,0);
    }
  }

  //

  &__bottom{
    position: absolute;
    bottom: 0;
    padding-left: 6rem;
    padding-bottom: 6rem;
    color: white;
    .title-h2{
      margin-bottom: 1.5rem;
      font-size: 5rem;
      span{
        color: white;
      }


      @media #{$bp-sm}{
        font-size: 3.6rem;
        line-height: 3.2rem;
      }
    }
    @media #{$bp-sm}{
      padding-left: 3.5rem;
      padding-bottom: 3.5rem;
    }
  }
  &__bg-gradient{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,1));
    transform: translate3d(0, 40%, 0);
    transition: all .5s ease;
  }

  &:hover{
    .event__bg-gradient{
      transform: translate3d(0, 10%, 0);
    }
  }

  .small{
    opacity: 0.7;
  }

  &__logos{
    position: absolute;
    top: 6rem;
    left: 5rem;
    @media #{$bp-sm}{
      top: 3.5rem;
      left: 3.5rem;
    }
    li{
      margin-right: 2rem;
    }
    img{
      width: 12.5rem;
      @media #{$bp-sm}{
        width: 9rem;
      }
    }
  }

  &--abo{
    text-align: center;
    > div{
      background-color: black;
    }
    .title-h2{
      margin-bottom: 2rem;
      span{
        color: white;
      }

      @media #{$bp-sm}{
        font-size: 3.6rem;
        line-height: 3.2rem;
      }
    }

    .logo{
      width: 13.8rem;
      display: inline-block;
      position: relative;
      margin-bottom: 3rem;

      @media #{$bp-sm}{
        width: 10rem;
        margin-bottom: 2rem;
      }
    }

    .abs--center{
      width: 100%;
    }

    .round-button:last-child{
      margin-bottom: 0;
    }
  }

  .round-button{
    // width: 130px;
    // margin: 0;
    // @media #{$bp-md-up}{
    //   position: absolute;

    //   bottom: 6rem;
    //   right: 6rem;
    // }

    &.mobile{
      margin-top: 1.5rem;
    }
  }
}
</style>

<script>
import Parallax from './Parallax.vue'

export default {
  components: { Parallax },
  props:['event', 'parallax'],
  data() {
    return {
      doClick: true,
      screenX: 0
    };
  },
  methods: {
    mousedown(e){
      this.screenX = e.screenX
    },
    mouseup(e){
      if( Math.abs( this.screenX - e.screenX ) > 5 ){
        this.doClick = false
      }
    },
    canClick(e){
      if( ! this.doClick ){
        e.preventDefault()
      }

      this.doClick = true
    }
  },
  mounted() {

  },
};
</script>
